import { CouponTypeCode } from "project-config/constants";
import CloseIcon from "@/assets/icons/topup/close";
import CheckIcon from "@/assets/icons/topup/renderbus-check";

enum ChargeType {
  Recharge = "Recharge",
  Membership = "Membership",
}

interface MemberLevelProps {
  type: number;
  vipMonth: number;
  price: number;
  originalPrice: number;
  perMonth?: number;
  badgeText?: string;
  vipPresentMonth?: number;
  iconWord?: string;
}

// 效果图首充
export const PictureFirstRechargeInfo = [
  {
    price: 1,
    giftAmount: 25,
    badgeText: "充值1元得26元",
  },
  {
    price: 200,
    giftAmount: 48,
    badgeText: "火爆热销中",
  },
  {
    price: 1000,
    giftAmount: 288,
    badgeText: "性价比最高",
  },
];

// 效果图常规余额充值
export const PictureNormalRechargeInfo = [20, 50, 200, 1000];

// 效果图首充规则
export const PictureFirstRechargeRule = [
  "1.活动仅限Renderbus效果图用户参与。",
  "2.首充福利专享每个用户仅限参与一次。",
  "3.活动期间首充福利和限时充值福利可以同时参与，到账渲染券为叠加福利。",
  "4.赠送的渲染券即时到账，请及时查看账户余额，如有问题请及时联系客服。",
  "5.本活动最终解释权归瑞云科技股份有限公司所有。",
];

// 效果图常规充值规则
export const rechargeRules = [
  "1.充值完成后立即到账，请及时查看账户余额。",
  "2.您可前往【个人中心-发票管理】开具发票。",
  "3.如在充值过程中遇到任务问题，请及时联系客服。",
];

// 常规会员充值规则
export const vipRules = [
  "1.渲染时系统会先按并行计费方式扣除费用，用户选择已计费的作业使用免单券，平台将自动原路返还相应作业的费用(包括优惠券);",
  "2.会员用户每月可自行选择作业进行免单，仅可用于当月会员期间内提交并计费的作业；",
  "3.每张免单券仅可使用一次,若已免单作业在原作业上重提渲染后,不可再次使用免单券；",
  "4.订阅会员每月赠送的免单券有效期为30天;",
  "5.充值赠送的免单券有效期与当月会员有效期一致，具体参考《效果图会员协议》及券面有效期。",
];

export interface IVipRechargeInfo {
  type: number;
  vipMonth: number;
  price: number;
  originalPrice: number;
  perMonth?: number;
  badgeText?: string;
}

export const VipRechargeInfo: IVipRechargeInfo[] = [
  {
    type: 1,
    vipMonth: 1,
    price: 19.9,
    originalPrice: 25,
  },
  {
    type: 3,
    vipMonth: 3,
    price: 58,
    originalPrice: 75,
    perMonth: 19.3,
    badgeText: "特惠",
  },
  {
    type: 6,
    vipMonth: 6,
    price: 110,
    originalPrice: 150,
    perMonth: 18.3,
  },
  {
    type: 2,
    vipMonth: 12,
    price: 199,
    originalPrice: 300,
    perMonth: 16.5,
  },
];

export const initVerifyRechargeInfo = {
  activityId: 0,
  couponAmount: 0,
  couponNO: "",
  rechargeAmount: 0,
  couponType: CouponTypeCode.Universal,
};

export enum TipType {
  NotSatisfied = "Not satisfied",
  Satisfied = "Satisfied",
}

type TipTypeProp = {
  icon: React.ReactElement;
  preTitle: string;
  titleColor: string;
};

export const CouponCodeTipList: Record<TipType, TipTypeProp> = {
  [TipType.NotSatisfied]: {
    icon: <CloseIcon />,
    preTitle: "不满足",
    titleColor: "color-fill-13",
  },
  [TipType.Satisfied]: {
    icon: <CheckIcon />,
    preTitle: "满足",
    titleColor: "color-text-9",
  },
};

export { ChargeType };
export type { MemberLevelProps };
